<template>
  <v-card class="px-2 mx-4 elevation-1 mb-2">
    <ExcelActions :query="query" :loading="loading" />

    <v-card-text>
      <template>
        <div>
          <div class="d-flex">
            <div v-if="filterParam.subject" class="text-h6 text-uppercase" style="color: #0d47a1">
              {{ title }}
            </div>
            <v-spacer />
            <v-btn @click="saveMarks" color="primary">Lưu</v-btn>
          </div>

          <div class="d-flex table-container pt-4">
            <v-form ref="form">
              <table class="mark-table">
                <thead>
                  <tr>
                    <th class="position-sticky-1">STT</th>
                    <th class="position-sticky-2">Học sinh</th>
                    <th class="position-sticky-3">Ngày sinh</th>
                    <th class="position-sticky-4" v-if="isClassShown">Lớp</th>
                    <th v-for="factor in factors" :key="factor.id" :colspan="factor.maxCol">
                      {{ factor.title }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, studentIndex) in studentMarks" :key="item.student.id">
                    <td class="position-sticky-1">{{ studentIndex + 1 }}</td>
                    <td class="px-2 py-0 position-sticky-2" style="text-align: left">
                      <CardStudentName :student="item.student" link isGlobalCodeShown />
                    </td>
                    <td class="position-sticky-3">{{ item.student.dob | ddmmyyyy }}</td>
                    <td class="position-sticky-4" v-if="isClassShown">{{ item.student.currentClassTitle }}</td>
                    <td
                      v-for="(mark, markIndex) in item.marks"
                      :key="markIndex"
                      class="mark-text-field ma-0 px-2"
                      :class="{ 'mark-text-field': isMarkTypeNumber, 'evaluate-text-field': !isMarkTypeNumber }"
                    >
                      <div v-if="mark.markInDate">
                        <v-text-field
                          v-if="isMarkTypeNumber"
                          class="mark-text-field"
                          v-model="mark.value"
                          @input="handlerInput($event, mark, studentIndex, markIndex)"
                          hide-details
                          outlined
                          dense
                          :rules="[$rules.markInput]"
                          maxlength="2"
                          :ref="`input-${studentIndex}-${markIndex}`"
                          @keydown.tab.prevent="tab(`input-${studentIndex + 1}-${markIndex}`)"
                        />
                        <v-autocomplete
                          v-else
                          :items="evaluateItems"
                          v-model="mark.value"
                          outlined
                          dense
                          hide-details
                          clearable
                          append-icon=""
                          class="evaluate-text-field ma-0 px-2"
                          @input="handlerInput($event, mark, studentIndex, markIndex)"
                          :ref="`input-${studentIndex}-${markIndex}`"
                          @keydown.tab.prevent="tab(`input-${studentIndex + 1}-${markIndex}`)"
                        />
                      </div>
                      <ExistedMark
                        v-else
                        :mark="mark"
                        :type="isMarkTypeNumber ? 'mark' : 'evaluate'"
                        @on-existed-mark-click="() => markInOtherDateClicked(item.student, mark)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-form>
          </div>
          <div class="d-flex justify-end mt-4">
            <v-btn color="primary" @click="saveMarks">Lưu</v-btn>
          </div>
        </div>
      </template>
    </v-card-text>
    <MarkEditDialog
      :state="markEditDialog"
      :student="selectedStudent"
      :mark="selectedMark"
      @updatedMark="refresh(filterParam)"
    />
  </v-card>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { get, chunk } from 'lodash'
import MarkEditDialog from '@/modules/mark/MarkEditDialog.vue'
import ExcelActions from './class-input/ExcelActions.vue'
import { handleMarkInput } from './class-input/utils'
import moment from 'moment'
import ExistedMark from './class-input/ExistedMark.vue'

export default {
  components: {
    CardStudentName,
    MarkEditDialog,
    ExcelActions,
    ExistedMark
  },
  data() {
    return {
      markStudents: [],
      markEditDialog: false,
      selectedStudent: {},
      selectedMark: {},
      loading: false,
      evaluateItems: [
        { text: 'Đ', value: 1 },
        { text: 'KĐ', value: 0 }
      ]
    }
  },
  props: {
    query: Object
  },
  watch: {
    studentMarks: {
      handler(val) {
        this.markStudents = val
        this.$loading.active = false
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions('ClassMarkInput', ['fetchMarks', 'createMark', 'updateMark', 'removeMark']),
    async refresh(query) {
      this.$loading.active = true
      await this.fetchMarks(query)
    },
    async saveMarks() {
      if (!this.$refs.form.validate()) return this.$alert.error('Điểm phải trong khoảng từ 0 đến 10')
      const groups = chunk(this.markStudents, 3)
      for (let subMarkStudents of groups) {
        const promises = subMarkStudents.reduce((acc, cur) => {
          const markPromies = cur.marks.map(({ id, value, rawValue, factor }) => {
            if (id) {
              if (rawValue !== value) {
                if (value) return this.updateMark({ id, value })
                return this.removeMark(id)
              } else Promise.resolve()
            } else {
              if (parseFloat(value) >= 0) {
                return this.createMark({
                  student: cur.student.id,
                  value,
                  class: get(this.filterParam, 'class.id'),
                  subject: get(this.filterParam, 'subject'),
                  grade: get(this.filterParam, 'class.grade.id'),
                  semester: get(this.filterParam, 'semester.id'),
                  factor: factor.id,
                  date: moment()
                    .startOf('day')
                    .toISOString(),
                  staff: this.profile.id,
                  teacher: this.profile.id
                })
              } else {
                Promise.resolve()
              }
            }
          })
          return [...acc, ...markPromies]
        }, [])

        try {
          this.$loading.active = true
          await Promise.all(promises)
          this.$alert.success('Lưu điểm thành công')
        } catch (error) {
          this.$alert.error('Đã có lỗi xảy ra ' + error)
        } finally {
          this.$loading.active = false
        }
      }

      await this.refresh(this.filterParam)
    },
    markInOtherDateClicked(student, mark) {
      this.selectedStudent = student
      this.selectedMark = mark
      this.markEditDialog = !this.markEditDialog
    },
    tab(ref) {
      // tab theo chieu doc
      this.$refs[ref] && this.$refs[ref][0].focus()
    },
    handlerInput(value, mark, studentIndex, markIndex) {
      handleMarkInput(value, mark, studentIndex, markIndex, nextRef => this.tab(nextRef))
    }
  },
  computed: {
    ...mapState('ClassMarkInput', ['filterParam', 'factors', 'isClassExtraCurriculum']),
    ...mapGetters('ClassMarkInput', ['studentMarks']),
    ...mapGetters('auth', ['profile']),
    title() {
      if (this.filterParam.subject) {
        const subjectTitle = get(this.filterParam, 'subject.title', '')
        const divisionTitle = get(this.filterParam, 'class.division.title', '')
        const classTitle = get(this.filterParam, 'class.title', '')
        return `Môn ${subjectTitle} ${divisionTitle} - Lớp ${classTitle}`
      }
    },
    isClassShown() {
      return this.isClassExtraCurriculum
    },
    isMarkTypeNumber() {
      return get(this.filterParam, 'subject.markType') === 'mark'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-autocomplete.v-select.v-input--is-focused input {
    min-width: 0;
  }
}
.mark-text-field {
  width: 50px;
}
.evaluate-text-field {
  width: 90px;
}

.mark-table {
  td,
  tr,
  th {
    border: 1px solid #e0e0e0;
  }
  td,
  th {
    padding: 14px 20px;
    text-align: center;
  }
  color: #212121;
  border-collapse: collapse;
  width: 100%;
}
.table-container {
  overflow: auto;
  max-width: 100%;
}

.position-sticky-1 {
  position: sticky;
  left: -5px;
  z-index: 1;
  background-color: white;
}
.position-sticky-2 {
  position: sticky;
  left: 50px;
  z-index: 1;
  background-color: white;
}
.position-sticky-3 {
  position: sticky;
  left: 200px;
  z-index: 1;
  background-color: white;
}
.position-sticky-4 {
  position: sticky;
  left: 250px;
  z-index: 1;
  background-color: white;
}
</style>
